const common = {
    login: 'Inloggen',
    getStarted: 'Begin Nu',
    learnMore: 'Meer Ontdekken',
    bookNow: 'Boek Nu',
    viewDetails: 'Bekijk Details',
    backToTop: 'Terug Naar Boven',
    home: 'Home',
    features: 'Kenmerken',
    yourSaaS: 'La Dolce Vita',
    day: 'Dag',
    days: 'Dagen',
    night: 'Nacht',
    nights: 'Nachten',
    startingFrom: 'Vanaf',
    and: 'en',
    relatedTrips: 'Gerelateerde Reizen',
    relatedDestinations: 'Gerelateerde Bestemmingen',
    relatedActivities: 'Gerelateerde Activiteiten',
    includedInTrips: 'Inbegrepen in Reizen',
    availableAtDestinations: 'Beschikbaar op Bestemmingen',
    includesDestinations: 'Omvat de Bestemmingen',
    includesActivities: 'Omvat de Activiteiten',
    overview: 'Overzicht',
    details: 'Details',
    gallery: 'Galerij',
    related: 'Gerelateerd',
    duration: 'Duur',
    difficulty: 'Moeilijkheidsgraad',
    price: 'Prijs',
    items: 'artikelen',

    locations: 'Locaties',
    requirements: 'Vereisten',
    included: 'Inbegrepen',
    highlights: 'Hoogtepunten',
    activities: 'Activiteiten',
    activityNotFound: 'Activiteit Niet Gevonden',
    activityNotFoundDescription: 'De activiteit die je zoekt bestaat niet.',
    destinationNotFound: 'Bestemming Niet Gevonden',
    destinationNotFoundDescription: 'De bestemming die je zoekt bestaat niet.',
    productNotFound: 'Product Niet Gevonden',
    productNotFoundDescription: 'Het product dat je zoekt bestaat niet.',
    backToHome: 'Terug naar Home',
    loading: 'Laden...',
    retry: 'Opnieuw Proberen',
    map: 'Kaart',
    region: 'Regio',
    origin: 'Oorsprong',
    volume: 'Volume',
    additionalDetails: 'Aanvullende Details',
    altitude: 'Hoogte',
    surface: 'Oppervlakte',
    population: 'Inwoners',
    density: 'Dichtheid',
    length: 'Lengte',
    aboveSeaLevel: 'm.b.z.',
    updatedOn: 'bijgewerkt op',
    between: 'tussen',
    andMeters: 'en',
    meters: 'meter'
};

export default common;

